<template>
  <div class="" id="tblProducts_info" role="status" aria-live="polite" style="padding-top: 1.25em">
    Show
    <select @change="onChangeRecordsPerPage" v-model="recordsPerPage">
      <option :value="12">12</option>
      <option :value="25">25</option>
      <option :value="50">50</option>
      <option :value="100">100</option>
    </select>
    of {{ totalRecords }} entries
  </div>
</template>

<script>
export default {
  name: 'RowsPerPageSelect',
  props: {
    recordsPerPage: {
      type: Number,
      required: true
    },
    totalRecords: {
      type: Number,
      required: true
    }
  },
  methods: {
    onChangeRecordsPerPage(event) {
      this.$emit('records-per-page-changed', this.recordsPerPage);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/shared/RowsPerPageSelect.vue